import { React, useState } from 'react';
import Box from '@mui/material/Box';
import "./components.css";

function BigButton(props) {
  const [hovered, setHovered] = useState(false);

  const boxStyle = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '300px',
    height: '100px',
    color: 'black',
    zIndex: 2,
    border: '2px solid black',
    backgroundColor:  props.color,
    transition: 'all 0.1s ease-in-out',
    transform: hovered ? 'translate(10px, -10px)' : 'none',
    margin: 0,
  };

  const shadowStyle = {
    position: 'absolute',
    width: boxStyle.width,
    height: boxStyle.height,
    backgroundColor: '#000',
    zIndex: 1,
  };

  return (
    <Box 
      sx={{ position: 'relative', padding: '20px'}} 
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Box sx={shadowStyle} />
      <p style={boxStyle}>{props.content}</p>
    </Box>
      
  );
}

export default BigButton;
